import AddRolePermissions from './AddRolePermissions';

export default AddRolePermissions;
